<template>
    <div class="bank-page">
        <div class="bank-title">银行业ESG评级结果查询</div>
        <div class="bank-desc">《银行业ESG发展报告(2025)》样本银行ESG评级结果 2025-10发布</div>
        <div class="bank-msg">
  
          <div class='mask-desc'>  中国金融传媒股份有限公司、责扬天下(北京)管理顾问有限公司会同来自政府机构、可持续发展、社会责任、环境、治理、ESG、银行业等领域的权威专家组建专家委员会，制定《银行业ESG评价指标体系》，委托北京一标数字科技有限公司提供数据及算法服务，根据数据的可获得性和完整性，经沉淀后纳入本次评价范围的有效样本205家(样本银行名单见附件)，部分银行评级结果如下:
        </div>
            
           </div>
        <div class="bank-title1">上市银行ESG评级结果</div>

        <el-table
            :data="tableData"
            style="width: 100%"
            :header-row-class-name="'custom-head'"
            :row-class-name="tableRowClassName"
        >
            <el-table-column prop="name" label="公司名称" align="center"></el-table-column>
            <el-table-column prop="nature" label="公司性质" align="center"></el-table-column>
            <el-table-column prop="rating" label="评级结果" align="center"></el-table-column>
        </el-table>
        <div class="bank-title">非上市银行ESG评级结果</div>
        <el-table
            :data="unlistedList"
            style="width: 100%"
            :header-row-class-name="'custom-head'"
            :row-class-name="tableRowClassName"
        >
            <el-table-column prop="name" label="公司名称" align="center"></el-table-column>
            <el-table-column prop="nature" label="公司性质" align="center"></el-table-column>
            <el-table-column prop="rating" label="评级结果" align="center"></el-table-column>
        </el-table>
        <div class='view-btn' @click='tologin'>如需了解更多评级结果，请登录进行查询</div>
        <div class='fujian'>附件:</div>
        <div class='excl-btn'>
          <div class='left'>
          <img src="../assets/iconx.png" alt="" /> <span>205家样本银行名单</span>
          </div>
          <div class='right' @click='downxlsx'>下载</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BankPage',
    data() {
        return {
            tableData: [
                {
                    name: '中国工商银行',
                    nature: '国有大型商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '中国银行',
                    nature: '国有大型商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '兴业银行',
                    nature: '股份制商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '中国建设银行',
                    nature: '国有大型商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '招商银行',
                    nature: '股份制商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '中国农业银行',
                    nature: '国有大型商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '交通银行',
                    nature: '国有大型商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '中信银行',
                    nature: '股份制商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '北京银行',
                    nature: '城市商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '浦发银行',
                    nature: '股份制商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '中国邮政储蓄银行',
                    nature: '国有大型商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '民生银行',
                    nature: '股份制商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '光大银行',
                    nature: '股份制商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '江苏银行',
                    nature: '城市商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '华夏银行',
                    nature: '股份制商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '平安银行',
                    nature: '股份制商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '上海银行',
                    nature: '城市商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '浙商银行',
                    nature: '股份制商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '渤海银行',
                    nature: '股份制商业银行',
                    rating: 'AAAA',
                },
                {
                    name: '徽商银行',
                    nature: '城市商业银行',
                    rating: 'AAA',
                },
            ],
            unlistedList: [
                {
                    name: '广发银行',
                    nature: '股份制商业银行',
                    rating: 'AA',
                },
                {
                    name: '恒丰银行',
                    nature: '股份制商业银行',
                    rating: 'AA',
                },
                {
                    name: '汉口银行',
                    nature: '城市商业银行',
                    rating: 'AA',
                },
                {
                    name: '三湘银行',
                    nature: '民营银行',
                    rating: 'A',
                },
                {
                    name: '新网银行',
                    nature: '民营银行',
                    rating: 'A',
                },
                {
                    name: '淮安农商银行',
                    nature: '农村商业银行',
                    rating: 'A',
                },
                {
                    name: '绵阳市商业银行',
                    nature: '城市商业银行',
                    rating: 'A',
                },
                {
                    name: '沧州银行',
                    nature: '城市商业银行',
                    rating: 'A',
                },
                {
                    name: '如皋农商银行',
                    nature: '农村商业银行',
                    rating: 'A',
                },
                {
                    name: '湖州银行',
                    nature: '城市商业银行',
                    rating: 'A',
                },
                {
                    name: '四川银行',
                    nature: '城市商业银行',
                    rating: 'A',
                },
                {
                    name: '马鞍山农商银行',
                    nature: '农村商业银行',
                    rating: 'A',
                },
                {
                    name: '萧山农商银行',
                    nature: '农村商业银行',
                    rating: 'A',
                },
                {
                    name: '唐山银行',
                    nature: '城市商业银行',
                    rating: 'A',
                },
                {
                    name: '重庆三峡银行',
                    nature: '城市商业银行',
                    rating: 'A',
                },
                {
                    name: '遂宁银行',
                    nature: '城市商业银行',
                    rating: 'A',
                },
                {
                    name: '兴化农商银行',
                    nature: '农村商业银行',
                    rating: 'A',
                },
                {
                    name: '浙江网商银行',
                    nature: '民营银行',
                    rating: 'A',
                },
                {
                    name: '微众银行',
                    nature: '民营银行',
                    rating: 'A',
                },
                {
                    name: '太仓农商银行',
                    nature: '农村商业银行',
                    rating: 'A',
                },
            ],
        };
    },
    methods: {
      downxlsx(){
        window.open('https://api.oneesg.cn/file/static/website/205%E5%AE%B6%E6%A0%B7%E6%9C%AC%E9%93%B6%E8%A1%8C%E5%90%8D%E5%8D%95.xlsx')
      },
      tologin(){
        window.open('https://app.oneesg.cn/')
      },

        tableRowClassName({ rowIndex }) {
            if (rowIndex % 2 != 0) {
                return 'even-row odd-row';
            } else {
                return 'odd-row';
            }
        },
    },
};
</script>
<style lang="stylus">
.even-row{
    background-color #fAfafa !important;
}
.odd-row>.el-table__cell{
  height :40px;
  padding: 0 !important;
    border: none !important;
}
.custom-head{
    background-color: #fabe0d !important;
  height :40px;
}
.custom-head>.el-table__cell{
    background-color: #fabe0d !important;
 height :40px;
 padding: 0 !important;
 border: none !important;
 font-weight: normal!important;
}
.custom-head>.el-table__cell>.cell{
  padding: 0 !important;
  color #fff !important;
}
</style>
<style scoped lang="stylus">
.bank-page{
    width 677px;
    margin 0 auto;
    padding-bottom: 60px;
}

.bank-title{
  font-size 21px;
  font-weight bold;
  color #333;
  text-align center;
  margin 40px 0;
  position relative;
}
.bank-title::after{
    content: '';
    width: 242px;
    height: 11px;
    background-color: rgba(250, 190, 13, 0.2);
    position: absolute;
    left: 50%;
    bottom: -2px;
    transform: translateX(-50%);
}
.bank-title1{
  font-size 21px;
  font-weight bold;
  color #333;
  text-align center;
  margin 40px 0;
  position relative;
}
.bank-title1::after{
    content: '';
    width: 222px;
    height: 11px;
    background-color: rgba(250, 190, 13, 0.2);
    position: absolute;
    left: 50%;
    bottom: -2px;
    transform: translateX(-50%);
}
.bank-desc{
  font-size 12px;
  color #9f9f9f;
  text-align center;
  margin-bottom 20px;
}

.bank-msg{
  font-size 12px;
  color #333;
  line-height 1.8;
  margin-bottom 20px;
  text-align justify;
  padding 20px;
  position relative;
  border 1px solid #333;

  background #fff;
}
.mask-desc{
    width 100%;
  height 100%;
  position relative;
  
    background #fff;
  z-index 13;
}
.mask-bank{
  width 100%;
  height 100%;
  position absolute;
  background   #fabe0d
}

.view-btn{
  width 280px;
  height 40px;
  text-align center;
  margin 40px auto;
  font-size 14px;
  color #fff;
  display flex;
  align-items center;
  justify-content center;
  cursor pointer;
  border-radius 4px;
  background #fabe0d;

}

.fujian{
  font-size 14px;
  color #333;
}


.left{
 
   display flex;
  align-items center;
  span{
    font-size 14px;
    color #333;
    margin-left 10px;
  }
  img{
    width 40px;
    height 40px;
  }
}

.right{
  font-size 14px;
  cursor pointer;
  color #409EFF;
}

.excl-btn{
 width 100%;
 display flex;
  align-items center;
  border 1px solid #ebebeb;
  justify-content space-between;
  border-radius 4px;
  padding 10px;
}
@media only screen and (max-width: 768px) {

  .bank-page{
      width 100%;
      padding:0 10px;
      box-sizing border-box;
  }
}


</style>
